import { state } from "@angular/animations";

export const PHONE_NUMBER = '(800) 670-1839';
export const BRAND_NAME = 'Dr. Marty Pets';
export const BRAND_LOGO_REG = 'https://cdn.drmartypets.com/images/logo_green_registered.png';
export const BRAND_LOGO_GREEN = 'https://cdn.drmartypets.com/images/logo_green.png';
export const BRAND_LOGO_WHITE = 'https://cdn.drmartypets.com/images/logo_white.png';
